
import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

interface RoyaltyEarningsChartProps {
  data: {
    name: string;
    amount: number;
  }[];
}

const RoyaltyEarningsChart: React.FC<RoyaltyEarningsChartProps> = ({ data }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Royalty Earnings</CardTitle>
        <CardDescription>Quarterly breakdown of your royalties</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-80">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip formatter={(value) => [`$${value}`, 'Amount']} />
              <Line 
                type="monotone" 
                dataKey="amount" 
                stroke="#fab528" 
                strokeWidth={2} 
                dot={{ strokeWidth: 4 }} 
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};

export default RoyaltyEarningsChart;
